export const SOCIAL_LOGIN_OPTIONS = [
  {
    key: "simplici",
    image: "simplici.svg",
    disabled: true,
  },
  {
    key: "facebook",
    image: "facebook.svg",
  },
  {
    key: "google",
    image: "google.svg",
  },
  {
    key: "apple",
    image: "apple.svg",
  },
  {
    key: "microsoft",
    image: "microsoft.svg",
  },
];
